import {
  SetBankingAccountInput,
  SetBankingAccountMutation,
  useMutationNotifier,
  useSetBankingAccountMutation,
} from '@alice-financial/alice-sdk'
import { UseGqlMutationCallbacks, useMutationOptionsWithInvalidation } from '@alice-financial/api'
import { QueryKey, useMutation } from '@tanstack/react-query'
import { ConfirmBankAccountSetupResponse } from '../../externalServices/stripe/useConfirmBankAccount'

type UseSetBankingAccountMutationOptions = UseGqlMutationCallbacks<
  SetBankingAccountMutation,
  ConfirmBankAccountSetupResponse
>
export const useSetBankingAccount = (
  bankInfo: Pick<SetBankingAccountInput, 'ownerId' | 'ownerType' | 'routingNumber' | 'accountNumber'>,
  invalidationKeys: Array<QueryKey>,
  mutationOptions?: UseSetBankingAccountMutationOptions
) => {
  const mutationOptionsWithInvalidation = useMutationOptionsWithInvalidation(
    useMutationNotifier({}, mutationOptions),
    invalidationKeys
  )
  const { mutateAsync: setBankingAccount } = useSetBankingAccountMutation()
  return useMutation(
    ['setBankingAccount'],
    (confirmationResponse) => setBankingAccount({ input: { ...bankInfo, ...confirmationResponse } }),
    mutationOptionsWithInvalidation
  )
}
